import axios from "axios";
import { TypeEmail } from "../../Models/Email/EmailModels";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { EmailService } from "./EmailService";
import { DataTypeEmailMidis } from "../../Models/Admin/AdminModels";

export function TypeEmailService(){
    return{
        async getAllTypeEmail(token:any):Promise<TypeEmail[]>{
            let arrayTypeEmail:TypeEmail[] = []
            const response = await axios.get(`${URLAPI+'typesEmail'}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];
            for(const type of data){
                arrayTypeEmail.push({
                    id: type['id'],
                    type: type['type'],
                    emails:type['emails'],
                    description:type['description'],
                    actif: true
                });
            }
            return arrayTypeEmail;
        },

         async getAllTypeEmailClients(token:any):Promise<TypeEmail[]>{
            let arrayTypeEmail:TypeEmail[] = []
            const response = await axios.get(`${URLAPI+'typesEmail'}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const midisReg = new RegExp(`\\b${'MIDIS'}\\b`);
            const data = response.data['hydra:member'];
            for(const type of data){
                if(!midisReg.test(type['type']))
                    arrayTypeEmail.push({
                        id: type['id'],
                        type: type['type'],
                        emails:type['emails'],
                        description:type['description'],
                        actif: true
                    });
            }
            return arrayTypeEmail;
        },

        async getTypesEmailMIDIS(token:any):Promise<TypeEmail[]>{
            let arrayTypeEmail:TypeEmail[] = []
            const response = await axios.get(`${URLAPI+'typesEmail'}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const midisReg = new RegExp(`\\b${'MIDIS'}\\b`);
            const data = response.data['hydra:member'];
            for(const type of data){
                if(midisReg.test(type['type']))
                    arrayTypeEmail.push({
                        id: type['id'],
                        type: type['type'],
                        emails:type['emails'],
                        description:type['description'],
                        actif: true
                    });
            }
            return arrayTypeEmail;
        },

        async getTypeEmail(id:number, token:any){
            const response = await axios.get(`${URLAPI+'typeEmail/'+id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];
            if(data.length>0){
                const[emails] = await Promise.all([
                    EmailService().getEmailsFromUrlsToTypeEmail(data[0]['emails'], token)
                ]);
                return {
                    id: data[0]['id'],
                    type: data[0]['type'],
                    actif: data[0]['actif'],
                    description:data[0]['description'],
                    emails:emails
                };
            }
        },

        /**
         * Cette méthode permet de renvoyer un objet TypeEmail, rataché à un email, via une URL.
         * Pour éviter toute boucle infini via la relation entre un TypeEmail et son/ses email(s),
         * il est préférable de ne pas enregistrer la valeur lié à TypeEmail, ni de la transformer en objet TypeEmail. 
         * Donc celle-ci restera un objet TypeEmail|undefined, qui ici sera undefined. (Modification possible à l'avenir).
         * 
         * Si vous souhaitez accèder à l'email à partir de l'objet TypeEmail, alors employez la méthode ???
         */
        async getTypeEmailFromUrlToPromiseToEmail(url:string, token:string):Promise<TypeEmail>{
            let typeEmail : TypeEmail = {
                id: 0,
                type: "",
                emails:[],
                description:"",
                actif:false
            };
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                // console.log('data abonnement: ', data);
            
                let typeEmail : TypeEmail = {
                    id: data[0]['id'],
                    type: data[0]['type'],
                    emails:data[0]['emails'],
                    description:data[0]['description'],
                    actif:true
                };
                // console.log('abonnement: ', abonnement);
                return typeEmail;
            } catch (error) {
                errorService().handleError('Erreur lors du getTypeEmailFromUrlToPromiseToEmail', error)
                return typeEmail;
            }
        },

        /**
         * Cette méthode permet de renvoyer un objet TypeEmail, rataché à un email, via une URL.
         * Pour éviter toute boucle infini via la relation entre un TypeEmail et son/ses email(s),
         * il est préférable de ne pas enregistrer la valeur lié à TypeEmail, ni de la transformer en objet TypeEmail. 
         * Donc celle-ci restera un objet TypeEmail|undefined, qui ici sera undefined. (Modification possible à l'avenir).
         * 
         * Si vous souhaitez accèder à l'email à partir de l'objet TypeEmail, alors employez la méthode ???
         */
        async getTypeEmailFromString(role:string, token:string):Promise<TypeEmail>{
            let typeEmail : TypeEmail = {
                id: 0,
                type: "",
                emails:[],
                description:"",
                actif:false
            };
            try {
                const response = await axios.get(`${URLAPI+'typesEmail'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                // console.log('data abonnement: ', data);

                for(const type of data){
                    if(type.type.toLowerCase()===role.toLowerCase()){
                        typeEmail = {
                            id: data[0]['id'],
                            type: data[0]['type'],
                            emails:data[0]['emails'],
                            description:data[0]['description'],
                            actif:true
                        };
                        break;
                    }
                }
                return typeEmail;
            } catch (error) {
            errorService().handleError('Erreur lors du getTypeEmailFromUrlToPromiseToEmail', error)
                return typeEmail;
            }
        },

        async postTypeEmail(type:string, token:string){
            try {
                const postTypeEmailObject = {
                    "type":type,
                    "emails":[]
                }

                const reponsePostType = await axios.post(
                    `${URLAPI+'typeEmail'}`,
                    postTypeEmailObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                return reponsePostType.status;
            } catch (error) {
                errorService().handleError('Erreur ajout type email', error);
                return 400
            }
        },

        async patchTypeEmailMIDISAdmin(data:DataTypeEmailMidis, token:string){
            try {
                let status = 400;

                const patchTypeEmailObject = {
                    "type":data.nom,
                    "description":data.description,
                    // "emails":data.email
                }

                const reponsePostType = await axios.patch(
                    `${URLAPI+'typeEmail/'+data.id}`,
                    patchTypeEmailObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                status = reponsePostType.status;
                if(status===200 && !/^\s*$/.test(data.email.email)){
                    if(data.email.id===0){
                        status = await EmailService().postEmailTypeEmailMIDISAdmin(data.id, data.email.email, token);
                    }else{
                        status = await EmailService().patchEmailTypeEmailMIDISAdmin(data.email.id, data.email.email, token);
                    }
                }

                return status;
            } catch (error) {
                errorService().handleError('Erreur modification type mail', error);
                return 400
            }
        }
    }
}